import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';
import type { Treatment } from '@/types/components/whatIsYourConcern';

type Props = {
  treatment: Treatment;
};

const ScanCard = ({ treatment }: Props) => {
  const imagePath =
    treatment.image?.urlDesktop ||
    treatment.image?.urlMobile ||
    treatment.imageUrl ||
    '';
  const imageAlt = treatment.image?.alt || '';

  return (
    <div
      style={{ boxShadow: '0px 4px 6px 1px #0000001F' }}
      className="flex h-full w-full flex-col rounded-lg bg-white p-5"
    >
      {imagePath ? (
        <div className="mb-4 flex h-24 w-24 shrink-0 items-center justify-center rounded-lg">
          <R2Image
            path={imagePath}
            alt={imageAlt}
            width={96}
            height={96}
            className="h-24 w-24 object-contain"
          />
        </div>
      ) : null}

      <RichText styles={treatment.heading.styles}>
        {treatment.heading.content}
      </RichText>

      <RichText styles={treatment.description.styles}>
        {treatment.description.content}
      </RichText>
    </div>
  );
};

export default ScanCard;
